// extracted by mini-css-extract-plugin
export default {"firstCol":"pages_firstCol__wgsvl","secondCol":"pages_secondCol__kOXiV"};